import { createAction, props } from '@ngrx/store';

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { EstadosRol } from './entity\'estados-rol.models';

// LOAD
export const entityEstadosRolLoadRequest = createAction(
  '[ENTITYESTADOSROL] Load Request'
);

export const entityEstadosRolLoadFailure = createAction(
  '[ENTITYESTADOSROL] Load Failure',
  props<{ error: Error }>()
);

export const entityEstadosRolLoadSuccess = createAction(
  '[ENTITYESTADOSROL] Load Success',
  props<{ items: EstadosRol[] }>()
);
